import { Loader } from 'three';
import Deferred from './deferred';

class THREELoader<T> {
  target: Loader;
  private deferred?: Deferred<T>;

  constructor(target: Loader) {
    this.target = target;
  }

  load = (url: string | string[]) => {
    this.abort();
    const deferred = new Deferred<T>();

    ((deferred, url) => {
      //@ts-ignore
      this.target.load(
        url,
        function (r: any) {
          deferred?.resolve((r as unknown) as T);
        },
        undefined,
        function (e: any) {
          deferred?.reject(e);
        }
      );
    })(deferred, url);

    this.deferred = deferred;

    return this.deferred.promise;
  };

  abort = () => {
    this.deferred?.reject();
  };
}

export default THREELoader;
